import React, { useContext } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { FaEnvelope } from 'react-icons/fa'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { api } from '../../../services/api'

import scroll from '../../../util/scroll'

import { Textbox, Button } from '../../../components/Form'

import { Container, Content } from './styles'

const validation = Yup.object({
    email: Yup.string().email('E-mail incorreto.').required('Especifique o e-mail cadastrado no sistema.')
})

export default function () {
    scroll.toTop()

    const history = useHistory()

    async function handleSubmit({ email }) {
        try {
            const response = await api.post('pass_recover', { email })

            setTimeout(() => {
                history.push('/login')

                toast.info(response.msg)
            }, 1000)
        } catch (e) {
            toast.error(e.msg)
        }
    }

    return (
        <Container>
            <Content className="animated fadeInUp faster delay-300ms flex flex-col items-center bg-white text-slate-800">
                <Formik
                    initialValues={{ email: '' }}
                    validationSchema={validation}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form className="w-full">
                            <h1 className="text-slate-800">Recuperação de senha</h1>

                            <Textbox name="email" label="Seu e-mail" />

                            <Button type="submit" loading={isSubmitting}>Recuperar senha</Button>

                            <p>ou</p>

                            <Link to="/login" className="text-sky-500 hover:underline">Voltar para o login</Link>
                        </Form>
                    )}
                </Formik>

            </Content>
        </Container>
    )
}
